export default "__VITE_ASSET__Dg10lEes__"